import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { Environment } from '@rma/dashboard/generic/util/environment';
import { POSTHOG_EXCEPTION_CONTEXT } from '@rma/generic/util/posthog';
import { catchError, of } from 'rxjs';

/**
 * Tags every `$exception` with the profile being acted for, so a report can be traced to who was
 * affected. Email is left out on purpose, and the HQ link is derivable from tenant, type and code.
 */
export function provideRmaPostHogExceptionContext(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: POSTHOG_EXCEPTION_CONTEXT,
      useFactory: (): (() => Record<string, unknown>) => {
        // A failed profile lookup must not turn the error reporter into a second error.
        const profile = toSignal(
          inject(DashboardProfileContextService).profileIdentifierWithVertical$.pipe(catchError(() => of(undefined))),
        );
        const { tenant } = inject(Environment);

        return () => {
          const current = profile();

          if (!current) {
            return { tenant };
          }

          const { profileType, profileCode, verticalType } = current;

          return { profileType, profileCode, verticalType, tenant };
        };
      },
    },
  ]);
}
